<section class="ads-showcase">
  <div class="reusable-container flex flex-col gap-20 lg:gap-28">
    <article class="promo-row" *ngFor="let promo of promos; let i = index"
      [class.flipped]="!isEven(i)"
      [style.--promo-accent]="promo.accent">

      <div class="promo-copy">
        <div class="promo-eyebrow">
          <span class="dot"></span>
          {{ promo.eyebrow }}
        </div>
        <h3 class="promo-title">{{ promo.title }}</h3>
        <p class="promo-body">{{ promo.body }}</p>
        <a [href]="promo.ctaHref" class="promo-cta">
          {{ promo.ctaLabel }}
          <mat-icon class="!text-base !h-4 !w-4">arrow_forward</mat-icon>
        </a>
      </div>

      <div class="promo-media">
        <div class="promo-media-glow"></div>
        <div class="promo-media-frame">
          <ng-container *ngIf="promo.mediaType === 'video'; else promoImage">
            <video [src]="promo.media" autoplay muted loop playsinline
              class="promo-media-el"></video>
          </ng-container>
          <ng-template #promoImage>
            <img [src]="promo.media" [alt]="promo.title" class="promo-media-el" />
          </ng-template>
        </div>
      </div>
    </article>
  </div>
</section>
